<template lang='pug'>
.card-containerr
    van-popup(v-model='show', closeable)
        .topTitle 积分规则
        .title 如何获得积分
        .item-container
            .item 1. 关注圣戈班高功能塑料微信公众号并进入用户中心注册+200积分。
            .item 2. 每日签到+5积分。
        .item-container2
            .more 更多积分规则敬请期待
    .card-container
        .card
            .jifen-container1
                img.jifen(src='@/assets/imgs/积分@3x.png')
                .rule(@click='show = true') 积分规则
            .img-container
                img.head(:src='userInfo.headimgurl')
            .right-container
                .nickName 昵称: {{ userInfo.nickname }}
                .points 积分: {{ memberInfo.points }}
                .qiandao-container
                    img.qiandao(src='@/assets/imgs/签到@3x.png')
                    .every(@click='sign') 每日签到
</template>

<script>
import { getPointRecords } from '@/service/member'
import { mapState, mapActions } from 'vuex'
export default {

    data() {
        return {
            show: false,
            hasSigned: false
        }
    },
    computed: {
        ...mapState(['memberInfo', 'userInfo'])
    },
    methods: {
        ...mapActions(['getMemberInfo']),
        async sign() {
            if (this.hasSigned) {
                this.$message({
                    message: '您已经签到过啦'
                })
                return
            }
            let from = new Date(new Date().toLocaleDateString())
            const isSign = await getPointRecords({ index: 1, size: 1, from: from, to: new Date(), SourceDescriptions: ["803897150621954048"] })
            if (isSign.data.length != 0) {
                this.$message({
                    message: '您已经签到过啦'
                })
            } else {
                this.hasSigned = true
                this.$root.$emit('sign')
                this.$message({
                    message: '签到成功',
                    onClose: this.getMemberInfo
                })
            }
        }
    },
    async created() {
        this.$root.$emit('action', { name: this.$route.name })

    }
}
</script>

<style scoped lang='less'>
/deep/.van-popup--center {
    top: 55%;
}
/deep/.van-popup {
    box-shadow: 0rem 0.15rem 0.3rem 0rem rgba(0, 0, 0, 0.16);
    width: 15.15rem;
    color: #00448a;
    height: 22rem;
    border-radius: 0;
    overflow: auto;
    padding: 1.2rem 1rem 2.8rem 1rem;
    .topTitle {
        font-size: 0.8rem;
        text-align: center;
        margin-bottom: 1rem;
    }
    .item-container {
        margin-bottom: 1rem;
    }
    .item {
        line-height: 1.1rem;
        font-size: 0.6rem;
    }
    a {
        text-decoration: underline;
    }
}
/deep/.van-overlay {
    background-color: transparent;
}
.card-container {
    padding: 0rem 1rem 0rem 1rem;
    .right-container {
        display: flex;
        flex-direction: column;
        // align-items: center;
        justify-content: center;
        .nickName {
            color: #222222;
            line-height: 0.9rem;
            height: 0.9rem;
            margin-bottom: 0.2rem;
            margin-top: 0.5rem;
        }
        .points {
            color: #222222;
            line-height: 0.9rem;
            height: 0.9rem;
        }
        .qiandao-container {
            display: flex;
            align-items: center;
            height: 0.85rem;
            .qiandao {
                width: 0.55rem;
                height: 0.55rem;
                display: block;
                margin-right: 0.3rem;
            }
            .every {
                font-size: 0.6rem;
                color: #219cdc;
            }
        }
    }
    .card {
        .jifen-container1 {
            position: absolute;
            width: 3.6rem;
            display: flex;
            right: 0;
            top: 0.5rem;
            .rule {
                height: 0.8rem;
                font-size: 0.55rem;
                line-height: 0.8rem;
                color: #219cdc;
            }
            .jifen {
                display: block;
                width: 0.75rem;
                height: 0.75rem;
                margin-right: 0.2rem;
            }
        }

        height: 5.2rem;
        position: relative;
        background-image: url('https://oss.cloud.custouch.com/res/21681/个人资料背景.png');
        background-size: cover;
        border-radius: 0.3rem;
        padding: 1.05rem 0 1.05rem 0.5rem;
        display: flex;
        .img-container {
            margin-right: 0.5rem;
            width: 3.1rem;
            .head {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
    }
}
.more {
    text-align: center;
}
</style>